import { Toaster as Sonner, toast } from 'sonner';

/** Top-right, token-styled. Errors do not auto-dismiss (set `duration: Infinity` at the call site). */
export function Toaster() {
  return (
    <Sonner
      position="top-right"
      theme="system"
      toastOptions={{
        duration: 5000,
        classNames: { toast: '!bg-raised !text-fg !border-line !shadow-overlay !text-sm' },
      }}
    />
  );
}
export { toast };
